var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5565,
    cy: 26.9999,
    r: 25.9999,
    stroke: "#FFF8E8",
    strokeWidth: 1.23871
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6681 36.4822H21.4504C19.7621 36.4822 18.3828 35.1029 18.3828 33.4146V21.197C18.3828 19.5087 19.7621 18.1294 21.4504 18.1294H33.6681C35.3564 18.1294 36.7357 19.5087 36.7357 21.197V33.4146C36.7357 35.1105 35.3639 36.4822 33.6681 36.4822Z",
    stroke: "#FFF8E8",
    strokeWidth: 1.23871
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2328 30.6412C25.1222 31.5306 26.3055 32.0205 27.5642 32.0205C28.8229 32.0205 29.9987 31.5306 30.8956 30.6412C31.785 29.7518 32.2749 28.5685 32.2749 27.3098C32.2749 26.0511 31.785 24.8678 30.8956 23.9784C30.0062 23.089 28.8229 22.5991 27.5642 22.5991C26.3055 22.5991 25.1222 23.089 24.2328 23.9784C23.3434 24.8678 22.8535 26.0511 22.8535 27.3098C22.8535 28.5685 23.3434 29.7518 24.2328 30.6412Z",
    stroke: "#FFF8E8",
    strokeWidth: 1.23871
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1916 22.4437C33.6911 22.4437 34.0961 22.0388 34.0961 21.5392C34.0961 21.0397 33.6911 20.6348 33.1916 20.6348C32.6921 20.6348 32.2871 21.0397 32.2871 21.5392C32.2871 22.0388 32.6921 22.4437 33.1916 22.4437Z",
    stroke: "#FFF8E8",
    strokeWidth: 1.23871
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.0652d504db88190b7f14a3ecbc205e1c.svg";
export { ForwardRef as ReactComponent };